import { TitleCasePipe, UpperCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { UtcDatePipe } from '@epicuro-next/ataraxia/date';
import { getFilterValueLabel } from '@epicuro-next/constants/features/localization';
import { ProductFiltersFieldId } from '@epicuro-next/models/product-filters';
import { isDateFilter } from '@epicuro-next/utilities';
import {
  Filter,
  FilterDisplayValueTransformOption,
  FilterValueUnion,
} from 'graphql-api/gql-api-interfaces';

const upperCaseFilterIds: string[] = [
  ProductFiltersFieldId.Size,
  ProductFiltersFieldId.Catalog,
];
const noneTransformFilterIds: string[] = [ProductFiltersFieldId.Subsite];
const dateFormat = 'MMM yy';

@Pipe({
  name: 'filterValueDisplayName',
  standalone: false,
})
export class FilterValueDisplayNamePipe implements PipeTransform {
  public transform(filter: Filter, value: FilterValueUnion): string | null {
    const label = getFilterValueLabel(value.value) ?? value.displayName;

    if (
      filter.displayValueTransform ===
        FilterDisplayValueTransformOption.NoTransform ||
      noneTransformFilterIds.includes(filter.fieldId)
    ) {
      return label;
    }

    if (isDateFilter(filter)) {
      return this.utcDatePipe.transform(label, dateFormat);
    }

    if (shouldUpperCaseFilter(filter)) {
      return this.upperCasePipe.transform(label);
    }

    return this.titleCasePipe.transform(label);
  }

  constructor(
    private utcDatePipe: UtcDatePipe,
    private upperCasePipe: UpperCasePipe,
    private titleCasePipe: TitleCasePipe,
  ) {}
}

export function shouldUpperCaseFilter<
  T extends Pick<Filter, 'fieldId' | 'displayValueTransform'>,
>(filter: T) {
  return (
    filter.displayValueTransform ===
      FilterDisplayValueTransformOption.UpperCase ||
    upperCaseFilterIds.includes(filter.fieldId.toLowerCase())
  );
}
